// extracted by mini-css-extract-plugin
module.exports = {"stats-grid":"PostStatsGridUI__stats-grid___2Vd3e","reaction-image":"PostStatsGridUI__reaction-image___88y5J","info":"PostStatsGridUI__info___12kXI"};